import React from "react";

function Footer() {
  return (
    <div>
      <nav className="footer">
        <p className="footer-text"> © 2022 TherapyReady. All rights reserved.</p>
        <p className="footer-text">Proudly powered by Django, Heroku, React, and Netlify </p>
      </nav>
    </div>
  );
}

export default Footer;
